export function findLastIndex<T>(
  array: T[],
  predicate: (value: T, index: number, currentArray: T[]) => boolean
): number {
  let l = array.length;
  while (l--) {
    if (predicate(array[l], l, array)) return l;
  }
  return -1;
}

export function findLast<T>(
  array: T[],
  predicate: (value: T, index: number, currentArray: T[]) => boolean
): T | undefined {
  const foundIndex = findLastIndex<T>(array, predicate);

  return foundIndex === -1 ? undefined : array[foundIndex];
}

export const safeParseInt = <D>(value: string, defaultValue: D): number | D => {
  const parsedNumber = parseInt(value, 10);
  return isNaN(parsedNumber) ? defaultValue : parsedNumber;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const voidFunc = (): void => {};

export const isNumberInfinite = (value: number): boolean => !Number.isNaN(value) && !Number.isFinite(value);
